import { render, staticRenderFns } from "./InviteMorePermit.vue?vue&type=template&id=134bab6e"
import script from "./InviteMorePermit.vue?vue&type=script&lang=js"
export * from "./InviteMorePermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports